import * as React from "react";

function SvgPencil(props) {
  return <svg width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}><path d="M8.97581 3.25256L0 12.2297V16.0003H3.77059L12.7477 7.02448L8.97581 3.25256Z" fill="currentColor" /><path d="M15.6096 2.27629L13.7243 0.390992C13.203 -0.130331 12.359 -0.130331 11.839 0.390992L9.91907 2.31095L13.6897 6.08154L15.6096 4.16158C16.1309 3.64026 16.1309 2.79628 15.6096 2.27629Z" fill="currentColor" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/pencil_724770.svg";
export { SvgPencil as ReactComponent };